declare let vehDisplayName: string;
export const VEHDisplayName = (): string => {
  return typeof vehDisplayName !== "undefined" && vehDisplayName !== ""
    ? vehDisplayName
    : "Doctor of Optometry";
};
